export const FilterButtons = ({ label, options, selected, onSelect, testPrefix = "size", color = "#00FF66" }) => {
  if (!options.length) return null;
  const base = "min-w-[3.5rem] px-4 py-2.5 rounded-xl border text-base font-bold transition-all duration-200";
  const inactive = "bg-[#121212] text-white border-white/10 hover:border-white/40";
  const activeStyle = { backgroundColor: color, borderColor: color, color: "#050505" };
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={`${testPrefix}-filter`}>
      <span className="text-sm text-[#A0A0A0] mr-1 min-w-[4.5rem]">{label}</span>
      <button
        onClick={() => onSelect("")}
        className={`${base} ${!selected ? "" : inactive}`}
        style={!selected ? activeStyle : undefined}
        data-testid={`${testPrefix}-all`}
      >
        Todas
      </button>
      {options.map(opt => (
        <button
          key={opt}
          onClick={() => onSelect(selected === opt ? "" : opt)}
          className={`${base} ${selected === opt ? "" : inactive}`}
          style={selected === opt ? activeStyle : undefined}
          data-testid={`${testPrefix}-${opt}`}
        >
          {opt}
        </button>
      ))}
    </div>
  );
};

export const SizeButtons = ({ sizes, selected, onSelect }) => (
  <FilterButtons label="Tu talla:" options={sizes} selected={selected} onSelect={onSelect} testPrefix="size" />
);

export const BrandButtons = ({ brands, selected, onSelect }) => (
  <FilterButtons label="Marca:" options={brands} selected={selected} onSelect={onSelect} testPrefix="brand" color="#B026FF" />
);
